/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageUsersByTargetRow,
  ToolUsageUsersByTargetRow$inboundSchema,
} from "./toolusageusersbytargetrow.js";

/**
 * Cross-dimensional MCP and tool usage grouped by target and user identity
 */
export type GetToolUsageUsersByTargetResult = {
  /**
   * Cross-dimensional usage rows grouped by target and user identity
   */
  usersByTarget: Array<ToolUsageUsersByTargetRow>;
};

/** @internal */
export const GetToolUsageUsersByTargetResult$inboundSchema: z.ZodMiniType<
  GetToolUsageUsersByTargetResult,
  unknown
> = z.pipe(
  z.object({
    users_by_target: z.array(ToolUsageUsersByTargetRow$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "users_by_target": "usersByTarget",
    });
  }),
);

export function getToolUsageUsersByTargetResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageUsersByTargetResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageUsersByTargetResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageUsersByTargetResult' from JSON`,
  );
}
